import React, { useState, useRef, useEffect } from "react";
import { getHeroIcon } from "../../_helpers/heroicons";
import styles from "../styles/QurealRichEditor.module.css";

const HeadingDropdown = ({ editor }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    // Handle click outside to close dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // Get current heading level or "Normal" if no heading is active
    const getCurrentHeadingText = () => {
        if (editor.isActive("heading", { level: 1 })) return "Heading 1";
        if (editor.isActive("heading", { level: 2 })) return "Heading 2";
        if (editor.isActive("heading", { level: 3 })) return "Heading 3";
        if (editor.isActive("heading", { level: 4 })) return "Heading 4";
        if (editor.isActive("heading", { level: 5 })) return "Large Text";
        if (editor.isActive("heading", { level: 6 })) return "Small Text";

        // If it's a paragraph
        if (editor.isActive("paragraph")) return "Normal Text";
        return "Normal Text";
    };

    return (
        <div className={styles.dropdown} ref={dropdownRef}>
            <button
                onClick={() => setIsOpen(!isOpen)}
                className={`${styles.button} ${styles.dropdownToggle} ${styles.isActive}`}
                title="Text style"
            >
                <span className={styles.dropdownLabel}>
                    {getCurrentHeadingText()}
                </span>
                {getHeroIcon("chevron-down", { width: "12px" })}
            </button>

            {isOpen && (
                <div className={styles.dropdownMenu}>
                    <button
                        onClick={() => {
                            editor
                                .chain()
                                .focus()
                                .setHeading({ level: 6 })
                                .run();
                            setIsOpen(false);
                        }}
                        className={`${styles.dropdownItem} ${
                            editor.isActive("heading", { level: 5 })
                                ? styles.dropdownItemActive
                                : ""
                        }`}
                    >
                        <span>Small Text</span>
                    </button>
                    <button
                        onClick={() => {
                            editor.chain().focus().setParagraph().run();
                            setIsOpen(false);
                        }}
                        className={`${styles.dropdownItem} ${
                            editor.isActive("paragraph")
                                ? styles.dropdownItemActive
                                : ""
                        }`}
                    >
                        <span>Normal Text</span>
                    </button>
                    <button
                        onClick={() => {
                            editor
                                .chain()
                                .focus()
                                .setHeading({ level: 5 })
                                .run();
                            setIsOpen(false);
                        }}
                        className={`${styles.dropdownItem} ${
                            editor.isActive("heading", { level: 5 })
                                ? styles.dropdownItemActive
                                : ""
                        }`}
                    >
                        <span>Large Text</span>
                    </button>
                    <button
                        onClick={() => {
                            editor
                                .chain()
                                .focus()
                                .toggleHeading({ level: 4 })
                                .run();
                            setIsOpen(false);
                        }}
                        className={`${styles.dropdownItem} ${
                            editor.isActive("heading", { level: 4 })
                                ? styles.dropdownItemActive
                                : ""
                        }`}
                    >
                        <span>Heading 4</span>
                    </button>
                    <button
                        onClick={() => {
                            editor
                                .chain()
                                .focus()
                                .toggleHeading({ level: 3 })
                                .run();
                            setIsOpen(false);
                            console.log(
                                "After heading change:",
                                editor.getHTML()
                            );
                        }}
                        className={`${styles.dropdownItem} ${
                            editor.isActive("heading", { level: 3 })
                                ? styles.dropdownItemActive
                                : ""
                        }`}
                    >
                        <span>Heading 3</span>
                    </button>
                    <button
                        onClick={() => {
                            editor
                                .chain()
                                .focus()
                                .toggleHeading({ level: 2 })
                                .run();
                            setIsOpen(false);
                        }}
                        className={`${styles.dropdownItem} ${
                            editor.isActive("heading", { level: 2 })
                                ? styles.dropdownItemActive
                                : ""
                        }`}
                    >
                        <span>Heading 2</span>
                    </button>
                    <button
                        onClick={() => {
                            editor
                                .chain()
                                .focus()
                                .toggleHeading({ level: 1 })
                                .run();
                            setIsOpen(false);
                        }}
                        className={`${styles.dropdownItem} ${
                            editor.isActive("heading", { level: 1 })
                                ? styles.dropdownItemActive
                                : ""
                        }`}
                    >
                        <span>Heading 1</span>
                    </button>
                </div>
            )}
        </div>
    );
};

export default HeadingDropdown;
